import CloseIcon from '../../assets/icon-close.svg?react';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { SettingContext } from '@/context/SettingContext';
import notify from '@/services/notify';

interface ModelSelectProps {
  initiated: boolean;
  setInitiated: (boolean) => void;
}
const ModelSelect = ({ initiated, setInitiated }: ModelSelectProps) => {
  const [showModelModal, setShowModelModal] = useState(false);
  const { selectedModel, setSelectedModel, allModels, settingsIconRef } =
    useContext(SettingContext);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const closeModalRef = useRef<HTMLButtonElement | null>(null);
  const selectModelRef = useRef<HTMLSelectElement | null>(null);
  useEffect(() => {
    if (initiated) {
      setShowModelModal(true);
    }
  }, [initiated]);

  useEffect(() => {
    // function to close the modal if clicked outside
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (showModelModal) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleModalKeyDown);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleModalKeyDown);
    };
    //eslint-disable-next-line
  }, [showModelModal]);

  useEffect(() => {
    if (closeModalRef.current && showModelModal) {
      closeModalRef.current.focus();
    }
  }, [showModelModal]);

  const handleClose = () => {
    setShowModelModal(false);
    setInitiated(false);
    settingsIconRef.current?.focus();
  };

  const onModelSave = (e) => {
    const choosenModel = allModels.find((model: Model) => model.name_of_model === e.target?.value);
    if (choosenModel) {
      notify({
        message: 'Your Model has been updated',
        type: 'success',
      });
      setSelectedModel(choosenModel);
    }
    handleClose();
  };

  const handleCloseKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab' && event.shiftKey && selectModelRef.current) {
      event.preventDefault();
      selectModelRef.current?.focus();
    }
  };

  const handleModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  const handleSaveKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      closeModalRef.current?.focus();
    }
  };

  return (
    <>
      {showModelModal && (
        <div className="chat-menu-src-select" ref={modalRef}>
          <div className="d-flex">
            <div className=" text-avatar ps-2 flex-grow-1" data-testid="model-collection">
              Change Model
            </div>
            <Button
              className="close-data-collection"
              aria-label="close"
              data-testid="close-select-model-popup"
              title="Close"
              ref={closeModalRef}
              onKeyDown={handleCloseKeyDown}
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </Button>
          </div>
          <div className="d-flex">
            <Form.Select
              aria-label="models"
              onChange={onModelSave}
              data-testid="model-dropwdown"
              autoComplete="off"
              defaultValue={selectedModel.name_of_model}
              value={selectedModel.name_of_model}
              ref={selectModelRef}
              onKeyDown={handleSaveKeyDown}
            >
              {allModels &&
                (allModels.some((model) => model.consumer !== undefined)
                  ? allModels.filter((model) => model.consumer === 'user')
                  : allModels
                ).map((model, index) => (
                  <option key={index} value={model?.name_of_model}>
                    {model?.display_name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>
      )}
    </>
  );
};

export default ModelSelect;
